import { render, staticRenderFns } from "./BreadComponent.vue?vue&type=template&id=1e6ccb7a&"
import script from "./BreadComponent.vue?vue&type=script&lang=js&"
export * from "./BreadComponent.vue?vue&type=script&lang=js&"
import style0 from "./BreadComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports